
import { motion } from "framer-motion";

interface EmailSignatureProps {
  version: 1 | 2 | 3;
  isEditable?: boolean;
}

const EmailSignature = ({ version, isEditable = false }: EmailSignatureProps) => {
  const signatures = {
    1: (
      <div className="bg-white border border-gray-200 p-0 rounded max-w-md overflow-hidden">
        <div className="flex items-center">
          <div className="bg-[#374151] p-4 flex-shrink-0">
            <div className="font-funnel font-semibold text-xl text-white">
              qwip
            </div>
          </div>
          <div className="w-px bg-gray-200 h-12"></div>
          <div className="p-4">
            <div className="font-semibold text-base text-[#374151]">John Smith</div>
            <div className="text-sm text-gray-600">Co-Founder</div>
            <div className="text-sm text-gray-600">john@qwip.co.uk</div>
          </div>
        </div>
      </div>
    ),
    2: (
      <div className="bg-white border border-gray-200 p-0 rounded max-w-md overflow-hidden">
        <div className="flex items-center">
          <div className="bg-[#374151] p-4 flex-shrink-0">
            <div className="font-funnel font-semibold text-xl text-white">
              qwip
            </div>
          </div>
          <div className="w-px bg-gray-200 h-12"></div>
          <div className="p-4">
            <div className="font-semibold text-base text-[#374151]">John Smith</div>
            <div className="text-sm text-gray-600">Co-Founder</div>
            <div className="text-sm text-gray-600">john@qwip.co.uk</div>
            <div className="text-xs text-gray-500 mt-1">+44 7XXX XXX XXX</div>
          </div>
        </div>
      </div>
    ),
    3: (
      <div className="bg-white border border-gray-200 p-0 rounded max-w-lg overflow-hidden">
        <div className="flex items-center">
          <div className="bg-[#374151] p-4 flex-shrink-0">
            <div className="font-funnel font-semibold text-xl text-white">
              qwip
            </div>
          </div>
          <div className="w-px bg-gray-200 h-14"></div>
          <div className="p-4">
            <div className="font-semibold text-base text-[#374151]">John Smith</div>
            <div className="text-sm text-gray-600">Co-Founder, qwip</div>
            <div className="text-sm text-gray-600">john@qwip.co.uk</div>
            <div className="text-xs text-gray-500 mt-1">+44 7XXX XXX XXX</div>
            <div className="text-xs text-gray-500 italic">Flexible workspaces, anywhere</div>
          </div>
        </div>
      </div>
    )
  };

  return (
    <motion.div
      initial={{ opacity: 0, y: 10 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.3 }}
      className={isEditable ? "cursor-pointer hover:scale-105 transition-transform" : ""}
    >
      {signatures[version]}
    </motion.div>
  );
};

export default EmailSignature;
